<section class="sec-events-popup">
  <table>
    <tr class="item-row" *ngIf="audioTracks.length > 0">
      <td class="title-container">
        <div
          class="event-icon"
          inlineSVG="../../assets/icons/audio-icon.svg"
        ></div>
        <span class="audio-item-title">Audio</span>
      </td>
      <td class="list-container">
        <div
          class="audio-tracks"
          *ngFor="let track of audioTracks; let i = index; let last = last"
        >
          <span class="language comma"
            >{{ track.properties.language
            }}<span [ngClass]="{ 'comma-hidden': last }">,</span></span
          >
        </div>
      </td>
    </tr>
    <tr class="item-row" *ngIf="subtitles.length > 0">
      <div class="title-container">
        <div
          class="event-icon"
          inlineSVG="../../assets/icons/subs-icon-capsul-black.svg"
        ></div>
        <span class="subtitles-item-title">Subtitles</span>
      </div>
      <div class="list-container">
        <div
          class="subtitles-list"
          *ngFor="let sub of subtitles; let i = index; let last = last"
        >
          <span class="language"
            >{{ sub.properties.language
            }}<span [ngClass]="{ 'comma-hidden': last }">,</span></span
          >
        </div>
      </div>
    </tr>
    <tr class="item-row" *ngIf="closedCaptions.length > 0">
      <div class="title-container">
        <div
          class="event-icon"
          inlineSVG="../../assets/icons/closed-captions-icon.svg"
        ></div>
        <span class="subtitles-item-title">Closed Captions</span>
      </div>
      <div class="list-container">
        <div
          class="subtitles-list"
          *ngFor="let cc of closedCaptions; let i = index; let last = last"
        >
          <span class="language"
            >{{ cc.properties.language
            }}<span [ngClass]="{ 'comma-hidden': last }">,</span></span
          >
        </div>
      </div>
    </tr>
  </table>
  <table class="events-table">
    <tr class="events-table-header">
      <td class="type-header">TYPE</td>
      <td class="name-header">NAME</td>
      <td class="duration-header">DURATION</td>
      <td class="offset-header">OFFSET</td>
    </tr>
    <tr class="events-row" *ngFor="let event of timedEvents; let i = index">
      <td class="type-text">
        <span
          class="event-icon"
          [inlineSVG]="imagesAndTitlesByType[event.type].image"
        ></span>
        <span>{{ imagesAndTitlesByType[event.type].title }}</span>
      </td>
      <td class="name-text">
        <span class="name-text">{{ event.properties.name }}</span>
      </td>
      <td class="property-text">{{ formatTime(event.properties.duration) }}</td>
      <td class="property-text">{{ formatTime(event.properties.offset) }}</td>
    </tr>
  </table>
  <button class="edit-button" (click)="onViewOptionChange()">EDIT</button>
</section>
